<template lang="pug">
    Modal
        .form
            h2 Create a New Market
            .form__control-group
                label Title
                input(
                    v-model="title"
                    type="text"
                    placeholder="Title"
                )
            .form__control-group.rule__control-group--select
                label Country
                select.form__select(
                    v-model="country"
                )
                    option(
                        value=""
                        disabled
                        selected
                    ) Select Country
                    option(
                        :key="country.name"
                        v-for="(country, index) in allCountries"
                        :value="country.name"
                    ) {{country.name}}
            .form__control-group.rule__control-group--select
                label Language
                select.form__select(
                    v-model="language"
                )
                    option(
                        value=""
                        disabled
                        selected
                    ) Select Language
                    option(
                        :key="language.name"
                        v-for="(language, index) in allLanguages"
                        :value="language.code"
                    ) {{language.name}}
            .form__control-group
                label Activity Phrases
                .activity-phrases
                    label
                        input(
                            v-model="choosePhrase"
                            type="radio"
                            value="new"
                        )
                        | Create phrases from scratch
                    label
                        input(
                            v-model="choosePhrase"
                            type="radio"
                            value="copy"
                        )
                        | Copy phrases from existing market
                    select(
                        v-model="targetLocale"
                        v-if="choosePhrase === 'copy'"
                    )
                        option(
                            :value="market.locale"
                            v-for="market in getMarkets"
                        ) {{ market.title}}
            button.button__submit(
                @click="submit"
            ) Create
            p.validation__error(
                v-if="showError"
            ) Please enter a Title, Country, and Language
</template>
<script>
import Modal from '../general/Modal';
import store from '../../store';
import { postResource } from '../../services/Utils';
import allLanguages from '../../static/languages';
import staticCountries from '../../static/countries.json';
import Services from '../../services/Services';
import VueNotifications from 'vue-notifications';
export default {
  name: 'CreateMarket',
  components: {
    Modal
  },
  computed: {
    getMarkets() {
      return store.getters.getMarkets;
    }
  },
  data() {
    return {
      title: '',
      country: '',
      language: '',
      choosePhrase: 'new',
      targetLocale: null,
      allLanguages: allLanguages,
      allCountries: staticCountries,
      showError: false
    };
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  methods: {
    submit() {
      if (!this.title || !this.country || !this.language) {
        this.showError = true;
        return false;
      }
      const newMarket = {};

      const selectedCountry = this.allCountries.filter(country => {
        return country.name === this.country;
      })[0];

      newMarket.title = this.title;
      newMarket.country = selectedCountry.alpha3;
      newMarket.region = selectedCountry.alpha3;
      newMarket.locale = `${this.language}-${selectedCountry.alpha2}`;
      newMarket.language = this.language;
      newMarket.primaryLanguage = this.language;
      newMarket.region = selectedCountry.alpha3;
      newMarket.storeUrlPrefix = selectedCountry.alpha2;

      if (this.choosePhrase === 'new') {
        newMarket.content = 'new';
      } else {
        newMarket.content = this.targetLocale;
      }

      postResource('/v1/markets/create', false, newMarket)
        .then(res => {
          console.log('success!', res);
          this.showSuccessMsg({ message: `${this.title} market created!` });
          store.commit('hideModals', true);
          Services.getMarkets();
          return res;
        })
        .catch(error => {
          let message = 'An error occurred. Please try again.';
          if (error.message) {
            message = error.message;
          }
          this.showErrorMsg({
            message
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.form {
  padding: 2rem;
  display: flex;
  // align-items: center;
  justify-content: center;
  flex-direction: column;

  h2 {
    text-align: center;
    width: 100%;
  }

  .form__control-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    width: 100%;

    label {
      margin-bottom: 5px;
    }

    &:after {
      top: 20px !important;
    }

    input {
      padding-left: 0.5rem;
      height: 40px;
    }

    select,
    option {
      text-transform: capitalize;
    }
  }
}
.activity-phrases {
  label {
    display: block;
    margin-bottom: 0;
  }
  input {
    position: relative;
    top: 14px;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/CreateMarket.vue